import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Videos = () => {
  return (
    <Box>
      <Typography
        variant="h4"
        color="#071783"
        sx={{ fontWeight: 400 }}
        paddingTop={"3%"}
      >
        Videos
      </Typography>
    </Box>
  );
};

export default Videos;
